// extracted by mini-css-extract-plugin
export var actions = "_vi-4";
export var item = "_vi-1";
export var price = "_vi-3";
export var quantity = "_vi-2";
export var table = "_vi-0";